export class CaptionsPlayer {
  constructor(game, vo) {
    this._game = game;
    this._captionsModel = new CaptionsModel(game.cache, [
      'ui_captions',
      'scenarioshare_captions',
      'scenario1_captions',
      'scenario2_captions',
      'scenario3_captions',
      'scenario4_captions',
    ]);
    this.setCustomCaptions();
    if (vo) {
      this.vo = vo;
      this.vo.on('vo_start', this.startCaption, this);
      this.vo.on('vo_end', this.stopCaption, this);
    }
  }

  getCaption(id) {
    return this._captionsModel.getCaption(id);
  }

  setCustomCaptions() {
    const style = {
      fontSize: '38px',
      fontFamily: 'sans-serif',
      color: '#1d4a7a',
      background: 'rgba(181,250,207, 0.8)',
      paddingTop: '14px',
      paddingBottom: '14px',
      // paddingLeft: '10px',
      // paddingRight: '10px',
      bottom: '0',
      left: '0',
      position: 'absolute',
      // left: '50%',
      // transform: 'translateX(-50%)',
      transform: '',
      textAlign: 'center',
      width: '100%',
    };
    this._game.captions.enabled = this._game.settings.captions;
    this._game.captions.style = style;
  }

  startCaption(opts) {
    const captions = this._captionsModel.getCaption(opts.id);
    if (captions) {
      this._game.captions.show(captions);
    }
  }

  stopCaption() {
    this._game.captions.hide();
  }

  destroy() {
    this.vo.off('vo_start', this.startCaption, this);
    this.vo.off('vo_end', this.stopCaption, this);
    this.vo = null;
    this._game = null;
  }
}

export class CaptionsModel {
  constructor(cache, configs) {
    this.configs = configs;
    this.configsById = {};
    for (const id of configs) {
      this.configsById[id] = cache.json.get(id);
    }
    this.allCaptions = this.configs.reduce((acc, id) => {
      acc = { ...acc, ...this.configsById[id] };
      return acc;
    }, {});
    // CONVERT
    // from { "content": "Hello friend! How are you?", "start": 0, "end": 2419 }
    // to   { "copy": "Hello friend! How are you?", "duration": 2419 }
    this.convertedCaptions = Object.keys(this.allCaptions).reduce((acc, key) => {
      const data = this.allCaptions[key];
      acc[key] = data.reduce((acc, obj) => {
        acc.push({ copy: obj.content, duration: obj.end - obj.start });
        return acc;
      }, []);
      return acc;
    }, {});
  }

  // get allCaptions() {
  //   return this.configs.reduce((acc, id) => {
  //     acc = { ...acc, ...this.configsById[id] };
  //     return acc;
  //   }, {});
  // }

  getCaption(id) {
    return this.convertedCaptions?.[id] ?? {};
  }
}
